import {
  MDBCard,
  MDBCardBody,
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Spinner from "../Spinner/Spinner";
import "./DataTable.css";
import { useDispatch } from "react-redux";
import axiosGet from "../../helpers/axiosGet";
import { setDetailFromCargo } from "../../store/detail/actions";
import { useState } from "react";
import FloatingAlert from "../FloatingAlert";

const StyledDetail = styled.button`
  background: #006881;
  color: #fff;
  padding: 6px 12px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
`;

export default function DataTableBundle(props) {
  const { rows, headers, loading, error, page, totalPage, handlePage } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [errorSubmitClaim, setErrorSubmitClaim] = useState(null);
  const [show, setShow] = useState(false);
  const [loadingSubmitClaim, setLoadingSubmitClaim] = useState(null);

  const handleSubmitClaim = (refId) => {
    setLoadingSubmitClaim(refId);
    axiosGet({
      url: `/polismall-claim-cargo/declaration/ref-id/${refId}`,
      callback: (res) => {
        const data = res.data;
        dispatch(setDetailFromCargo(data));

        setTimeout(() => {
          navigate("/klaim");
        }, 1000);
      },
      errorCallback: (err) => {
        setLoadingSubmitClaim(null);
        setErrorSubmitClaim(err);
        console.log(err);
        setErrorSubmitClaim(true);
        setTimeout(() => {
          setShow(false);
        }, 5000);
      },
    });
  };

  return (
    <MDBCard shadow="0">
      <MDBCardBody>
        {loading ? (
          <Spinner height={75} />
        ) : error ? (
          <div className="text-danger fw-bold text-center">{error.message}</div>
        ) : rows.length ? (
          <>
            <MDBTable hover responsive>
              <MDBTableHead>
                <tr>
                  {headers.map((header, index) => (
                    <th scope="col" key={index}>
                      {header.name}
                    </th>
                  ))}
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <div>{row?.certificateNumber || "-"}</div>
                      <div>{row?.policyNumber || "-"}</div>
                    </td>
                    <td>
                      <div>{row?.insured || "-"}</div>
                    </td>
                    <td>
                      <div>{row?.portLoading || "-"}</div>
                      <div>{row?.portDestination || "-"}</div>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <StyledDetail
                          onClick={() => handleSubmitClaim(row.refId)}
                          disabled={loadingSubmitClaim}
                        >
                          {loadingSubmitClaim === row.refId ? "Loading..." : "SUBMIT CLAIM"}
                        </StyledDetail>
                      </div>
                    </td>
                  </tr>
                ))}
              </MDBTableBody>
            </MDBTable>

            {totalPage > 1 && (
              <div className="mt-3 d-flex justify-content-center justify-content-md-end">
                <ReactPaginate
                  previousLabel={<MDBIcon icon="chevron-left" />}
                  nextLabel={<MDBIcon icon="chevron-right" />}
                  breakLabel={"..."}
                  pageCount={totalPage}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={2}
                  forcePage={page - 1}
                  onPageChange={handlePage}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            )}
          </>
        ) : (
          <div className="fw-bold text-center">NO DATA</div>
        )}
      </MDBCardBody>

      <FloatingAlert
        message={""}
        show={show}
        error={errorSubmitClaim}
        handleClose={() => setShow(false)}
      />
    </MDBCard>
  );
}
